import { render, staticRenderFns } from "./ProductLink.vue?vue&type=template&id=4d33fbd3&"
import script from "./ProductLink.vue?vue&type=script&lang=js&"
export * from "./ProductLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports